define('shared/page/market',[
    'shared/util/state', 
    'shared/util/state/adapters/page',
    './runmode'
], function (
    state, 
    pageAdapter,
    getRunMode
) {
    'use strict';

    var KEY = 'page.market';

    return function(isRetrieving){
        var runmode = null;
        return getRunMode()
            .then(function(mode){
                runmode = mode;
                return state.adapters.add(pageAdapter);
            })
            .then(function(){
                if (isRetrieving && runmode !== 'author') {
                    return state
                        .retrieve(KEY);
                }
                else {
                    return state
                        .get(KEY)
                        .then(function(values){
                            var ret = values[0];
                            if (ret == null && runmode === 'author') {
                                return 'gb';
                            }
                            else {
                                return values[0] || '';
                            }
                        });
                }
            });
    };
});
